// eslint-disable import/no-cycle
// eslint-disable-next-line import/no-cycle
import {
  loadUsers,
  loadAvailableWorkers,
  loadWorkerDetails,
  loadDomains,
  getAllTenantUsers,
  getAllPendingUsers,
  inviteNewUsers,
  updateCustomerProfile,
  loadCustomerProfileDetails,
  updateCompanyCustomerProfile,
  loadCompanyCustomerProfileDetails,
  loadServiceProviderWorkerProfile,
  updateServiceProviderWorkerProfile,
  loadServiceProviderCompanyProfile,
  updateServiceProviderCompanyProfile,
  updateServiceProviderFreelancerProfile,
  loadServiceProviderFreelancerProfile,
  loadServiceProviderCompanyFullServicesOptions,
  loadServiceProviderCompanyFullRegionsOptions,
  loadCompanyCustomerFullRegionsOptions,
  loadCompanyCustomerFullRegulationsOptions,
  loadCompanyCustomerFullIndustriesOptions,
  loadProfile,
  loadServiceProvidersOfCompany,
  loadServiceProviderEmployeeAllData,
  deleteServiceProviderEmployee,
  changeServiceProviderEmployeeActiveStatus,
  editServiceProviderProfileByAdmin,
  loadSPProfile,
  validateTld,
  updateSensitivity, updateSystemSettings, getSystemSettings, deleteUser, tenantAdminChangeUserRole, addNewConfiguration,
  deletePendingUser, saveEditedUser, resetUserPassword,
  loadLicensing,
} from '@/services/repository';

import {
  LOAD_CUSTOMER_PROFILE_DETAILS,
  LOAD_USERS,
  CHANGE_USERS_LIST_OPTIONS,
  LOAD_WORKERS,
  CHANGE_WORKERS_LIST_OPTIONS,
  CHANGE_DOMAINS_LIST_OPTIONS,
  LOAD_WORKER_DETAILS,
  LOAD_NEEDED_ACTIONS,
  LOAD_DOMAINS,
  CLEAR_DOMAINS,
  LOAD_ALL_TENANT_USERS,
  CLEAR_TENANT_USERS_LIST,
  ADMIN_INVITE_USERS,
  TOGGLE_IS_SERVICE_PROVIDER,
  UPDATE_CUSTOMER_PROFILE,
  UPDATE_COMPANY_CUSTOMER_PROFILE,
  LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS,
  LOAD_SERVICE_PROVIDER_WORKER_PROFILE,
  UPDATE_SERVICE_PROVIDER_WORKER_PROFILE,
  LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS,
  UPDATE_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS,
  LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE,
  UPDATE_SERVICE_PROVIDER_FREELANCER_PROFILE,
  LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS,
  LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS,
  LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS,
  LOAD_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS,
  LOAD_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS,
  LOAD_SERVICE_PROVIDERS_OF_COMPANY,
  LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE,
  DELETE_SERVICE_PROVIDER_EMPLOYEE_USER,
  LOAD_CHOSEN_SERVICE_PROVIDER_EMPLOYEE_ID,
  CHANGE_SERVICE_PROVIDER_EMPLOYEE_ACTIVE_STATUS,
  UPDATE_SERVICE_PROVIDER_WORKER_PROFILE_BY_ADMIN,
  LOAD_SERVICE_PROVIDER_EMPLOYEE_BEFORE_EDIT,
  VALIDATE_TLD,
  UPDATE_SENSITIVITY,
  ADMIN_SYSTEM_SETTINGS,
  GET_SYSTEM_SETTINGS,
  DELETE_USER,
  ADMIN_CHANGE_USER_ROLE,
  DISABLE_DELETE_USER_BUTTON,
  DELETE_PENDING_USER,
  CHANGE_USER_DETAILS_FOR_EDIT,
  CLEAR_CHANGE_USER_DETAILS_FOR_EDIT,
  SAVE_USER,
  RESET_USER_PASSWORD,
  CLEAR_RESET_USER_PASSWORD,
  UPDATE_DOMAIN_SCAN_SETTINGS,
  LOAD_LICENSING,
} from '@/store/user/actionTypes';
import { createLoadingAction, createRunMutationAction } from '@/store/utils';
import { SET_PROFILE } from '@/store/auth/mutationTypes';
import { SET_WORKFLOWS } from '@/store/workflow/mutationTypes';
import { LOAD_DOMAINS_FROM_CONFIGURATION } from '@/store/project/actionTypes';
import {SET_SUCCESS_OPERATION_MESSAGE} from '@/store/configuration/mutationTypes';
import {CONFIGURATION} from '@/constants/configuration';
import { SET_DEFAULT_LICENSE } from '@/store/license/actionTypes';
import {
  SET_USERS,
  CLEAR_TENANT_USERS,
  CLEAR_USERS,
  SET_TENANT_USERS,
  SET_USERS_LIST_OPTIONS,
  SET_DOMAINS_LIST_OPTIONS,
  SET_WORKERS,
  CLEAR_WORKERS,
  SET_WORKERS_LIST_OPTIONS,
  SET_WORKER_DETAILS,
  CLEAR_WORKER_DETAILS,
  SET_DOMAINS,
  SET_NEEDED_ACTIONS,
  SET_SCAN_DATA,
  SET_IS_SERVICE_PROVIDER,
  SET_CUSTOMER_PROFILE_DETAILS,
  CLEAR_CUSTOMER_PROFILE_DETAILS,
  SET_COMPANY_CUSTOMER_PROFILE_DETAILS,
  CLEAR_COMPANY_CUSTOMER_PROFILE_DETAILS,
  SET_SERVICE_PROVIDER_WORKER_PROFILE,
  CLEAR_SERVICE_PROVIDER_WORKER_PROFILE,
  SET_SERVICE_PROVIDER_COMPANY_PROFILE,
  CLEAR_SERVICE_PROVIDER_COMPANY_PROFILE,
  CLEAR_SERVICE_PROVIDER_FREELANCER_PROFILE,
  SET_SERVICE_PROVIDER_FREELANCER_PROFILE,
  SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS,
  SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING,
  SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING_ERRORS,
  SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS,
  SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING,
  SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING_ERRORS,
  SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS,
  SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING,
  SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING_ERRORS,
  SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS,
  SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING_ERRORS,
  SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING,
  SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS,
  SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING,
  SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING_ERRORS,
  SET_SERVICE_PROVIDERS_OF_COMPANY,
  SET_CURRENT_SP_EMPLOYEE,
  SET_SERVICE_PROVIDER_EMPLOYEE_ID,
  SET_SP_EMPLOYEE_BEFORE_EDIT,
  SET_COMPANY,
  SET_FEATURES,
  SET_LICENSE_DATA,
  SET_LOADING_VALIDATION,
  SET_SYSTEM_SETTINGS,
  SET_DISABLE_DELETE_USER_BUTTON,
  SET_PENDING_USERS, CLEAR_PENDING_USERS,
  SET_DELETE_USER_LOADING, CLEAR_DELETE_USER_LOADING,
  SET_USER_DETAILS_FOR_EDIT, CLEAR_USER_DETAILS_FOR_EDIT,
  SET_NEW_USER_PASSWORD, CLEAR_NEW_USER_PASSWORD,
} from './mutationTypes';

export default {
  async [VALIDATE_TLD]({ commit, dispatch }, payload) {
    commit(SET_LOADING_VALIDATION, true);
    try {
      const result = await validateTld(payload);
      return result;
    } catch (e) {
      console.error(e);
      return false;
    } finally {
      await dispatch(LOAD_DOMAINS_FROM_CONFIGURATION);
      commit(SET_LOADING_VALIDATION, false);
    }
  },
  async [UPDATE_SENSITIVITY]({ dispatch }, payload) {
    try {
      await updateSensitivity(payload);
    } catch (e) {
      console.error(e);
    } finally {
      await dispatch(LOAD_DOMAINS_FROM_CONFIGURATION);
    }
  },
  async [UPDATE_DOMAIN_SCAN_SETTINGS]({ dispatch }, payload) {
    try {
      await addNewConfiguration({
        data: [{
          metaData: [
          ],
          data: payload.tld,
          tld: payload.tld,
          settingsMetaData: {
            scanSettings: payload.scanSettings,
          },
        }],
        configType: CONFIGURATION.CONFIG_TYPES.SCAN_SETTINGS,
      });
    } catch (e) {
      console.error(e);
    } finally {
      await dispatch(LOAD_DOMAINS_FROM_CONFIGURATION);
    }
  },
  async [UPDATE_SERVICE_PROVIDER_WORKER_PROFILE_BY_ADMIN]({ dispatch, commit }, payload) {
    try {
      await editServiceProviderProfileByAdmin(payload);
      await dispatch(LOAD_SERVICE_PROVIDERS_OF_COMPANY);
      const updatedProfile = await loadSPProfile();
      commit(SET_PROFILE, updatedProfile);
    } catch (e) {
      console.log(e);
    }
  },
  async [CHANGE_SERVICE_PROVIDER_EMPLOYEE_ACTIVE_STATUS]({ dispatch }, payload) {
    try {
      await changeServiceProviderEmployeeActiveStatus(payload);
      await dispatch(LOAD_SERVICE_PROVIDERS_OF_COMPANY);
    } catch (e) {
      console.log(e);
    }
  },
  async [LOAD_CHOSEN_SERVICE_PROVIDER_EMPLOYEE_ID]({ commit }, payload) {
    try {
      commit(SET_SERVICE_PROVIDER_EMPLOYEE_ID, payload);
    } catch (e) {
      console.log(e);
    }
  },
  async [DELETE_SERVICE_PROVIDER_EMPLOYEE_USER]({ dispatch }, payload) {
    try {
      await deleteServiceProviderEmployee(payload);
      await dispatch(LOAD_SERVICE_PROVIDERS_OF_COMPANY);
    } catch (e) {
      console.log(e);
    }
  },
  async [LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE]({ commit }, payload) {
    try {
      const employeeData = await loadServiceProviderEmployeeAllData(payload);
      await commit(SET_CURRENT_SP_EMPLOYEE, employeeData);
    } catch (e) {
      console.log(e);
    }
  },
  async [LOAD_SERVICE_PROVIDER_EMPLOYEE_BEFORE_EDIT]({ commit }, payload) {
    try {
      const employeeData = await loadServiceProviderEmployeeAllData(payload);
      commit(SET_SP_EMPLOYEE_BEFORE_EDIT, employeeData);
    } catch (e) {
      console.log(e);
    }
  },
  async [LOAD_SERVICE_PROVIDERS_OF_COMPANY]({ commit }) {
    try {
      const serviceProviders = await loadServiceProvidersOfCompany();
      commit(SET_SERVICE_PROVIDERS_OF_COMPANY, serviceProviders);
    } catch (e) {
      console.log(e);
    }
  },
  async [TOGGLE_IS_SERVICE_PROVIDER]({ commit }, value) {
    try {
      commit(SET_IS_SERVICE_PROVIDER, value);
    } catch (e) {
      console.log(e);
    }
  },

  async [ADMIN_CHANGE_USER_ROLE]({ commit }, options) {
    try {
      const successMessageType = options.successMessageType || '';
      await tenantAdminChangeUserRole(options.id, { userRoles: options.roles });
      commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
    } catch (e) {
      console.error('Error while changing user role:', e);
      throw e;
    }
  },

  async [ADMIN_INVITE_USERS]({ dispatch, commit }, options) {
    try {
      const successMessageType = options.successMessageType || '';
      await inviteNewUsers(options);
      commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
      await dispatch(LOAD_ALL_TENANT_USERS);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async [ADMIN_SYSTEM_SETTINGS]({commit}, payload) {
    const settings = await updateSystemSettings(payload);
    commit(SET_SYSTEM_SETTINGS, settings);
  },

  // Read-only load of system settings. Use on mount/refresh instead of
  // ADMIN_SYSTEM_SETTINGS (a POST write) so simply opening a settings page never
  // re-pushes keywords and triggers a redundant infostealers scan.
  async [GET_SYSTEM_SETTINGS]({commit}) {
    const settings = await getSystemSettings();
    commit(SET_SYSTEM_SETTINGS, settings);
  },

  async [LOAD_USERS]({ commit, getters }) {
    try {
      const { items: users } = await loadUsers(getters.userListOptions);
      commit(SET_USERS, users);
    } catch (e) {
      console.error('Load users error:', e);
      commit(CLEAR_USERS);
    }
  },

  [LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS]: createLoadingAction({
    method: loadCompanyCustomerFullRegionsOptions,
    dataKey: 'companyCustomerFullRegionsOptions',
    settingDataMutation: SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS,
    settingLoadingMutation: SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING,
    settingErrorMutation: SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING_ERRORS,
  }),

  [LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS]: createLoadingAction({
    method: loadCompanyCustomerFullIndustriesOptions,
    dataKey: 'serviceProviderCompanyFullIndustriesOptions',
    settingDataMutation: SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS,
    settingLoadingMutation: SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING,
    settingErrorMutation: SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING_ERRORS,
  }),

  [LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS]: createLoadingAction({
    method: loadCompanyCustomerFullRegulationsOptions,
    dataKey: 'serviceProviderCompanyFullRegulationsOptions',
    settingDataMutation: SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS,
    settingLoadingMutation: SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING,
    settingErrorMutation: SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING_ERRORS,
  }),

  async [LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE]({ commit }) {
    try {
      const profile = await loadServiceProviderFreelancerProfile();
      commit(SET_SERVICE_PROVIDER_FREELANCER_PROFILE, profile);
      const updatedProfile = await loadSPProfile();
      commit(SET_PROFILE, updatedProfile);
    } catch (e) {
      console.error('Error while loading service provider freelancer profile', e);
      commit(CLEAR_SERVICE_PROVIDER_FREELANCER_PROFILE);
    }
  },

  async [UPDATE_SERVICE_PROVIDER_FREELANCER_PROFILE]({ dispatch }, updates) {
    try {
      await updateServiceProviderFreelancerProfile(updates);
      await dispatch(LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE);
    } catch (e) {
      console.error('Error while updating service provider freelancer profile', e);
    }
  },

  [LOAD_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS]: createLoadingAction({
    method: loadServiceProviderCompanyFullServicesOptions,
    dataKey: 'serviceProviderCompanyFullServicesOptions',
    settingDataMutation: SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS,
    settingLoadingMutation: SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING,
    settingErrorMutation: SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING_ERRORS,
  }),

  [LOAD_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS]: createLoadingAction({
    method: loadServiceProviderCompanyFullRegionsOptions,
    dataKey: 'serviceProviderCompanyFullRegionsOptions',
    settingDataMutation: SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS,
    settingLoadingMutation: SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING,
    settingErrorMutation: SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING_ERRORS,
  }),

  async [LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS]({ commit }) {
    try {
      const company = await loadServiceProviderCompanyProfile();
      commit(SET_SERVICE_PROVIDER_COMPANY_PROFILE, company);
    } catch (e) {
      console.error('Error while loading service provider company profile', e);
      commit(CLEAR_SERVICE_PROVIDER_COMPANY_PROFILE);
    }
  },

  async [UPDATE_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS]({ dispatch }, updates) {
    try {
      await updateServiceProviderCompanyProfile(updates);
      await dispatch(LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS);
    } catch (e) {
      console.error('Error while updating service provider company profile');
    }
  },

  async [LOAD_CUSTOMER_PROFILE_DETAILS]({ commit }) {
    try {
      const customerProfile = await loadCustomerProfileDetails();
      commit(SET_CUSTOMER_PROFILE_DETAILS, customerProfile);
      const profile = await loadProfile();
      commit(SET_PROFILE, profile);
    } catch (e) {
      console.error('Error while getting customer profile data', e);
      commit(CLEAR_CUSTOMER_PROFILE_DETAILS);
    }
  },

  async [LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS]({ commit }) {
    try {
      const companyDetails = await loadCompanyCustomerProfileDetails();
      commit(SET_COMPANY_CUSTOMER_PROFILE_DETAILS, companyDetails);
    } catch (e) {
      console.error('Error while getting company customer profile data', e);
      commit(CLEAR_COMPANY_CUSTOMER_PROFILE_DETAILS);
    }
  },

  async [UPDATE_CUSTOMER_PROFILE]({ dispatch }, payload) {
    try {
      await updateCustomerProfile(payload);
      await dispatch(LOAD_CUSTOMER_PROFILE_DETAILS);
    } catch (e) {
      console.error('Error while updating customer profile data', e);
      throw e;
    }
  },

  async [UPDATE_COMPANY_CUSTOMER_PROFILE]({ dispatch }, payload) {
    try {
      await updateCompanyCustomerProfile(payload);
      await dispatch(LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS);
    } catch (e) {
      console.error('Error while updating company customer profile data', e);
    }
  },

  async [LOAD_ALL_TENANT_USERS]({ commit }) {
    try {
      const tenantUsers = await getAllTenantUsers();
      commit(SET_TENANT_USERS, tenantUsers);
      const pendingUsers = await getAllPendingUsers();
      commit(SET_PENDING_USERS, pendingUsers);
    } catch (e) {
      console.error('Load all users from tenant error:', e);
      commit(CLEAR_TENANT_USERS);
      commit(CLEAR_PENDING_USERS);
    }
  },

  async [CLEAR_TENANT_USERS_LIST]({ commit }) {
    try {
      commit(CLEAR_TENANT_USERS);
    } catch (e) {
      console.log(e);
    }
  },

  async [LOAD_WORKERS]({ commit, getters }, options) {
    try {
      const { items: workers } = await loadAvailableWorkers(getters.userListOptions, options);
      commit(SET_WORKERS, workers);
    } catch (e) {
      console.error('Load workers error:', e);
      commit(CLEAR_WORKERS);
    }
  },

  async [LOAD_SERVICE_PROVIDER_WORKER_PROFILE]({ commit }) {
    try {
      const profile = await loadServiceProviderWorkerProfile();
      commit(SET_SERVICE_PROVIDER_WORKER_PROFILE, profile);
      const updatedProfile = await loadSPProfile();
      commit(SET_PROFILE, updatedProfile);
    } catch (e) {
      console.error('Error while loading service provider worker profile data', e);
      commit(CLEAR_SERVICE_PROVIDER_WORKER_PROFILE);
    }
  },

  async [UPDATE_SERVICE_PROVIDER_WORKER_PROFILE]({ dispatch }, updates) {
    try {
      await updateServiceProviderWorkerProfile(updates);
      await dispatch(LOAD_SERVICE_PROVIDER_WORKER_PROFILE);
    } catch (e) {
      console.error('Error while updating service provider profile', e);
    }
  },

  async [LOAD_NEEDED_ACTIONS]({ commit }, { options }) {
    try {
      const company = await loadDomains(options);
      let actions = [];

      if (company !== null && company.advisedActions === []) {
        commit(SET_NEEDED_ACTIONS, actions);
      } else {
        actions = company.advisedActions;
        commit(SET_NEEDED_ACTIONS, actions);
      }
    } catch (e) {
      console.error('get actions error:', e);
      commit(SET_NEEDED_ACTIONS, []);
    }
  },

  [CLEAR_USERS]: createRunMutationAction(CLEAR_USERS),
  async [CHANGE_USERS_LIST_OPTIONS]({ commit, dispatch }, options) {
    commit(SET_USERS_LIST_OPTIONS, options);

    await dispatch(LOAD_USERS);
  },

  [CLEAR_WORKERS]: createRunMutationAction(CLEAR_WORKERS),
  async [CHANGE_WORKERS_LIST_OPTIONS]({ commit, dispatch }, options) {
    commit(SET_WORKERS_LIST_OPTIONS, options);

    await dispatch(LOAD_WORKERS);
  },

  async [LOAD_WORKER_DETAILS]({ commit }, options) {
    try {
      const workerDetails = await loadWorkerDetails(options.id);
      commit(SET_WORKER_DETAILS, workerDetails);
    } catch (e) {
      console.error('Load worker details error:', e);
      commit(CLEAR_WORKER_DETAILS);
    }
  },

  async [LOAD_DOMAINS]({ commit, getters }) {
    try {
      const options = getters.profile?.company.id;
      let company;
      if (options) {
        company = await loadDomains(options);
      }

      let domains = [];
      let advisedActions = [];
      let scanData = [];
      let features = {};
      let workflows = [];
      let license = [];

      if (company !== undefined) {
        domains = [company.domain];
        advisedActions = company.advisedActions;
        scanData = company.scanData;
        features = company.features; // featureToggles
        workflows = company.workflows;
        license = company.license;
      }
      commit(SET_WORKFLOWS, workflows);
      commit(SET_DOMAINS, domains);
      commit(SET_NEEDED_ACTIONS, advisedActions);
      commit(SET_SCAN_DATA, scanData);
      commit(SET_COMPANY, company);
      commit(SET_FEATURES, features);
      commit(SET_DEFAULT_LICENSE, license);
    } catch (e) {
      console.error('get domains error:', e);
    }
  },

  [CLEAR_DOMAINS]: createRunMutationAction(CLEAR_DOMAINS),
  async [CHANGE_DOMAINS_LIST_OPTIONS]({ commit, dispatch }, options) {
    commit(SET_DOMAINS_LIST_OPTIONS, options);

    await dispatch(LOAD_DOMAINS);
  },
  async [DELETE_USER]({ dispatch, commit }, payload) {
    try {
      const successMessageType = payload.successMessageType || '';
      commit(SET_DELETE_USER_LOADING, true);
      await deleteUser(payload);
      commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
      await dispatch(LOAD_ALL_TENANT_USERS);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      commit(CLEAR_DELETE_USER_LOADING);
    }
  },
  async [DELETE_PENDING_USER]({ dispatch, commit }, payload) {
    try {
      const successMessageType = payload.successMessageType || '';
      commit(SET_DELETE_USER_LOADING, true);
      await deletePendingUser(payload);
      commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
      await dispatch(LOAD_ALL_TENANT_USERS);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      commit(CLEAR_DELETE_USER_LOADING);
    }
  },
  async [DISABLE_DELETE_USER_BUTTON]({ commit }, payload) {
    commit(SET_DISABLE_DELETE_USER_BUTTON, payload.userId);
  },
  async [CHANGE_USER_DETAILS_FOR_EDIT]({ commit }, payload) {
    try {
      commit(SET_USER_DETAILS_FOR_EDIT, payload);
    } catch (e) {
      console.log(e);
      commit(CLEAR_USER_DETAILS_FOR_EDIT);
    }
  },
  async [CLEAR_CHANGE_USER_DETAILS_FOR_EDIT]({ commit }) {
    commit(CLEAR_USER_DETAILS_FOR_EDIT);
  },
  async [SAVE_USER]({ dispatch }, payload) {
    try {
      await saveEditedUser(payload);
      dispatch(LOAD_ALL_TENANT_USERS);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async [RESET_USER_PASSWORD]({ commit }, payload) {
    try {
      const successMessageType = payload.successMessageType || '';
      const newPassword = await resetUserPassword(payload.user);
      commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
      commit(SET_NEW_USER_PASSWORD, newPassword);
    } catch (e) {
      console.error(e);
      commit(CLEAR_NEW_USER_PASSWORD);
      throw e;
    }
  },
  async [CLEAR_RESET_USER_PASSWORD]({ commit }) {
    commit(CLEAR_NEW_USER_PASSWORD);
  },
  async [LOAD_LICENSING]({ commit }) {
    try {
      const data = await loadLicensing();
      commit(SET_LICENSE_DATA, data);
    } catch (e) {
      // Non-fatal — empty state will show in the UI
      commit(SET_LICENSE_DATA, null);
    }
  },
};
